import {css} from '@isceco/widget-library2/external/lit'

export default css`
  :host {
    display: block;
    font-family: var(--isceco-font);
  }

  @media (max-width: 1500px) {
    svg {
      width: 100%;
      margin-left: 0;
    }
  }

  .inline {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .map {
    flex: 1;
    margin: 0 5%;
    position: relative;
  }

  .inline > .left, .inline > .right {
    min-width: 225px;
    max-width: 225px;
    flex: 0;
    display: flex;
    flex-direction: column;
    gap: var(--isceco-space-100);
  }

  /* POPUPS */

  h2 {
    margin: 0 0 var(--isceco-space-200);
    font-size: 0.8rem;
    margin-bottom: var(--isceco-space-100);
  }

  .section {
    width: 100%;
    font-size: 0.7rem;
  }

  .section > p {
    margin: 0;
  }

  .section > .bemerkung {
    color: var(--isceco-color-grey-700)
  }

  .section > .bemerkung > i {
    margin-right: var(--isceco-space-100);
  }

  .tacho {
    --tacho-width: 140px;
    --tacho-thick: 14px;
    --tacho-height: 70px; /* tacho-width / 2 */
    --tacho-inlay-width: 112px; /* tacho-width - 2 * tacho-thick */
    --tacho-inlay-height: 56px; /* tacho-width - tacho-thick */

    margin: var(--isceco-space-200) auto;
    position: relative;
    width: var(--tacho-width);
    height: var(--tacho-height);
    border-top-left-radius: var(--tacho-height);
    border-top-right-radius: var(--tacho-height);
  }

  .tacho > .inlay {
    background-color: var(--isceco-color-white-500);
    position: absolute;
    width: var(--tacho-inlay-width);
    height: var(--tacho-inlay-height);
    top: var(--tacho-thick);
    left: var(--tacho-thick);
    border-top-left-radius: var(--tacho-inlay-height);
    border-top-right-radius: var(--tacho-inlay-height);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }

  .tacho > .inlay > .amount {
    font-size: 0.7rem;
    font-weight: bold;
  }

  .label {
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 150px;
  }

  .label > .left {
    margin-left: 1ch;
  }

  /* HOVER ÜBERSICHT */

  .hover {
    position: absolute;
    pointer-events: none;
  }

  .hover.west {
    bottom: 31%;
    left: 33%;
  }

  .hover.deutsch {
    top: 25%;
    right: 46%;
  }

  .hover.tessin {
    bottom: 18%;
    right: 34%;
  }
`
